export const FETCH_CHANGE_PASSWORD_REQUEST = 'FETCH_CHANGE_PASSWORD_REQUEST'
export const FETCH_CHANGE_PASSWORD_SUCCESS = 'FETCH_CHANGE_PASSWORD_SUCCESS'
export const FETCH_CHANGE_PASSWORD_FALUIRE = 'FETCH_CHANGE_PASSWORD_FALUIRE'
export const FETCH_CLEAR_CHANGE_PASSWORD_FALUIRE = 'FETCH_CLEAR_CHANGE_PASSWORD_FALUIRE'
